<template>
  <div class="content-background">
    <div class="add-content">
      <div class="content">
        <div>
          <p class="content-label required">话题名称</p>
          <el-input
            clearable
            v-model.trim="name"
            placeholder="请输入话题名称"
            type="text"
            class="content-title-input"
            maxlength="45" :show-word-limit="true"></el-input>
            <span class="limit" v-show="name && name.length > 30">{{name? name.length: 0}}/45</span>
        </div>
        <div>
          <p class="content-label required">话题名称（英文）</p>
          <el-input
            clearable
            v-model.trim="nameEn"
            placeholder="请输入话题名称（英文）"
            type="text"
            class="content-title-input"
            maxlength="45" :show-word-limit="true"></el-input>
            <span class="limit" v-show="nameEn && nameEn.length > 30">{{nameEn? nameEn.length: 0}}/45</span>
        </div>
        <!-- <div>
          <p class="content-label required">话题类型</p>
          <div class="select">
            <el-select
              v-model.trim="topicType" 
              placeholder="请选择话题类型">
              <el-option
                v-for="item in topicTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div> -->
        <div>
          <div class="content-topic-divider"></div>
          <div class="content-footer">
            <el-button class="save" @click="$router.back()">取消</el-button>
            <el-button class="publish" @click="save" v-if="permissions.topic_add">添加</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/styles/content.scss'
import { mapGetters } from 'vuex';
import { addNewTag } from '@/api/basic/topic';
import { topicTypeOptions } from '@/const/crud/basic/tagtype';
export default {
  name: 'addTopic',
  computed: {
    ...mapGetters(['permissions']),
  },
  data() {
    return {
      name: '',
      nameEn: '',
      tagCode: '',
      topicType: 0,
      topicTypeOptions,
      sort: 0,
      dictId: 3,
      status: 1,
    }
  },
  methods: {
    async save () {
      const name = this.name;
      if (name === '' || name.trim() === '') {
        this.$message({
          message: '话题名称不能为空',
          type: 'warning'
        });
        return;
      }
      const nameEn = this.nameEn;
      if (nameEn === '' || nameEn.trim() === '') {
        this.$message({
          message: '话题名称（英文）不能为空',
          type: 'warning'
        });
        return;
      }
      const data = {};
      data.status = this.status;
      data.type = this.dictId;
      data.name = name;
      data.nameEn = nameEn;
      data.tagCode = this.tagCode;
      data.sort = this.sort;
      data.topicType = this.topicType;
      const response = await this.requestWrapper(addNewTag, data);
      if (!response || response.ok === false) {
        this.$message({
          message: response.message || '新增话题失败',
          type: 'error'
        });
      } else {
        this.$router.back();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content-background {
  .add-content {
    .required::before {
      content: "*";
      color: #f56c6c;
      margin-right: 4px;
    }
    .limit {
      font-size: 14px;
      color: #AFAFAF;
      margin-left: 12px;
    }
    .content-area {
      width: 920px;
      position: relative;
      .content-image-input {
        width: 100%;
        position: relative;
      }
      .limit {
        position: absolute;
        bottom: 8px;
        right: 8px;
      }
    }
    .content-footer {
      text-align: right;
    }
    .select {
      width: 600px;
      height: 36px;
      background: #FFFFFF;
      opacity: 1;
      border-radius: 4px;
      margin-bottom: 20px;
    }
  }
}
</style>
